import React from "react";
import { Link } from "react-router-dom";
import { Plane } from "lucide-react";

const columns = [
  {
    title: "Product",
    links: [
      { label: "Search", to: "/search" },
      { label: "Explore", to: "/explore" },
      { label: "Award Calendar", to: "/calendar" },
      { label: "Cabin Compare", to: "/cabin-compare" },
      { label: "Flight Tracker", to: "/tracker" },
      { label: "Points Wallet", to: "/wallet" },
      { label: "Wishlist", to: "/wishlist" },
      { label: "Alerts", to: "/alerts" },
      { label: "AI Assistant", to: "/chat" },
    ],
  },
  {
    title: "Compare",
    links: [
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/" },
      { label: "Pricing", to: "/pricing" },
      { label: "Login", to: "/login" },
      { label: "Sign Up", to: "/register" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-5 py-14">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-600 text-white">
                <Plane className="h-4 w-4" strokeWidth={2.5} />
              </span>
              <span className="text-lg font-extrabold tracking-tight text-slate-900">FindMyFlight</span>
            </Link>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-500">
              The fastest search engine for award travel. Find the best flights for your points and miles.
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-slate-900">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-slate-500 transition-colors hover:text-blue-600">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-6 text-sm text-slate-400 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} FindMyFlight. All rights reserved.</p>
          <p className="max-w-lg">Award pricing refreshes continuously and may change until ticketed — always confirm the final price with the airline before transferring points.</p>
        </div>
      </div>
    </footer>
  );
}
